/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_DE = {
  "  Checked by (signature)": "  Überprüft von (Unterschrift)",
  "! 3 of 4 types required:": "! 3 von 4 Typen erforderlich:",
  "! Min. 14 characters": "! Mind. 14 Zeichen",
  "! No name/username parts": "! Keine Teile von Name/Benutzername",
  "! No spaces": "! Keine Leerzeichen",
  "/ occasion": "/ Anlassfall",
  "A new password should be different than the current one": "Ein neues Passwort sollte anders sein als das aktuelle",
  "ACCEPTED": "AKZEPTIERT",
  "Active flights": "Aktive Flüge",
  "Add deicing/anti-icing": "De-Icing/Anti-Icing hinzufügen",
  "Add description": "Beschreibung hinzufügen",
  "Add description if there is a irregularity!": "Beschreibung hinzufügen, wenn es eine Unregelmäßigkeit gibt!",
  "Add line": "Zeile hinzufügen",
  "Add location where item was found": "Ort hinzufügen, an dem der gegenstand gefunden wurde",
  "Add note": "Notiz hinzufügen...",
  "add occasion": "anlass hinzufügen",
  "Add other location": "Anderen Standort hinzufügen",
  "Add row": "Zeile hinzufügen",
  "Add storage location": "Lagerort hinzufügen",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Füge deine Wiederherstellungs-E-Mail hinzu, damit wir dir einen Code schicken können, falls du dein Passwort vergisst.",
  "additional services": "Zusätzliche Dienstleistungen",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Nach dem Klicken auf 'BESTÄTIGEN' wird das Korrektur-MVT gesendet. Es kann erneut gesendet werden, wenn sich ALDT oder/und AIBT ändern.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "Nach dem Klicken auf 'BESTÄTIGEN' wird das MVT gesendet. Es kann erneut gesendet werden, wenn sich ALDT oder/und AIBT ändern.",
  "Agent's name:": "Name des Agents:",
  "Agent's signature:": "Unterschrift des Agents:",
  "Aircraft Damage": "Schäden am Luftfahrzeug",
  "Aircraft type": "Flugzeugtyp",
  "Airline": "Fluggesellschaft",
  "All": "Alle",
  "ALL": "ALLE",
  "All Airlines with Stocks": "Alle Fluggesellschaften mit Beständen",
  "An error occurred while trying to verify your email address.": "Beim Versuch, Ihre E-Mail-Adresse zu überprüfen, ist ein Fehler aufgetreten.",
  "and": " und ",
  "and/or": "und/oder",
  "Anti-icing": "Anti-Icing",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "E-Mails mit @aviapartner.aero oder @aviavip.com werden nicht akzeptiert!",
  "APPLY": "ANWENDUNG",
  "approved": "genehmigt",
  "Apr": "Apr",
  "Archived": "Archiviert",
  "Are you sure you want to change your password?": "Sind Sie sicher, dass Sie Ihr Passwort ändern möchten?",
  "Are you sure you want to exit the current process?": "Sind Sie sicher, dass Sie den aktuellen Vorgang beenden möchten?",
  "Are you sure you want to remove photo?": "Sind Sie sicher, dass Sie das Foto entfernen möchten?",
  "Are you sure you want to sign out?": "Sind Sie sicher, dass Sie sich abmelden wollen?",
  "area": "bereich",
  "Arrival MVT has been sent": "Arrival MVT wurde gesendet",
  "Arrival MVT not sent yet": "Arrival MVT nicht gesendet",
  "Arrival MVT sending": "Arrival MVT wird gesendet",
  "Arrival MVT sent successfully": "Arrival MVT erfolgreich gesendet",
  "Attach photo": "Foto anhängen",
  "Attachment": "Anhang",
  "Aug": "Aug",
  "Available": "Verfügbar",
  "Belt": "Gurt",
  "Body": "Körper",
  "Briefly describe where the item will be stored for picking up.": "Beschreiben Sie kurz, wo der Gegenstand zur Abholung gelagert wird.",
  "Call {{firstName}} {{lastName}}": "Rufen Sie {{firstName}} {{lastName}} an",
  "Call sign": "Rufzeichen",
  "Cancel": "Stornieren",
  "CANCEL": "STORNIEREN",
  "Cannot be after": "Kann nicht danach sein ",
  "Cannot be before": "Kann nicht vorher sein ",
  "Cannot create MVT message: missing flight information": "MVT Message kann nicht erstellt werden: fehlende Fluginformationen",
  "Cannot send Arrival MVT": "Arrival MVT kann nicht gesendet werden. Adressen (SITA und/oder Email) sind nicht in Sunrise konfiguriert.",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Ankunft MVT kann nicht gesendet werden. Adressen (SITA und/oder E-Mail) für diesen Flug sind in Sunrise nicht konfiguriert.",
  "Cannot send MVT ETD": "MVT ETD kann nicht gesendet werden. Adressen (SITA und/oder Email) sind nicht in Sunrise konfiguriert.",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "MVT ETD kann nicht gesendet werden. Adressen (SITA und/oder E-Mail) für diesen Flug sind in Sunrise nicht konfiguriert.",
  "Cannot set a future time.": "Es kann keine zukünftige Zeit eingestellt werden.",
  "Change": "Ändern Sie",
  "Change password": "Passwort ändern",
  "Change password?": "Passwort ändern?",
  "Change your password:": "Ändern Sie Ihr Passwort:",
  "Checked by (signature)": "Überprüft von (Unterschrift)",
  "Checks on easily visible parts of the aircraft from the ground": "Überprüft leicht sichtbare Teile des Flugzeugs vom Boden:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Überprüfungen an leicht sichtbaren Teilen des Flugzeugs vom Boden aus. Keine offensichtlichen Schäden oder Anomalien an:",
  "Chocks": "Drosseln",
  "Chute": "Chute",
  "CLEAR": "löschen",
  "Client's signature:": "Unterschrift des Kunden:",
  "Clocked Time": "Erfasste Zeit",
  "Close": "Schließen",
  "CLOSE": "SCHLIESSEN",
  "Close all my sessions on all devices": "Schließe alle meine Sitzungen auf allen Geräten",
  "Close registration": "Registrierung abschließen",
  "CLOSE REGISTRATION": "REGISTRIERUNG SCHLIESSEN",
  "close the flight": "den Flug beenden",
  "Closed": "Geschlossen",
  "Closing this window will discard all your recent changes.": "Durch das Schließen dieses Fensters werden alle Ihre jüngsten Änderungen verworfen.",
  "Clouds": "Wolken",
  "Comment": "Kommentar",
  "Comment...": "Kommentar...",
  "Comments": "Bemerkungen",
  "Completed": "Abgeschlosse",
  "Conditional services": "Bedingte Leistungen",
  "Cones": "Kegel",
  "CONFIRM": "BESTÄTIGEN",
  "Confirm": "Bestätigen",
  "Confirm new password": "Neues Passwort bestätigen",
  "Confirm remove?": "Bestätigen Sie das Entfernen?",
  "CONFIRMED": "BESTÄTIGT",
  "Contact your administrator to request access": "Kontaktieren Sie Ihren Administrator, um Zugriff zu beantragen",
  "Could not save data, please try again later": "Daten konnten nicht gespeichert werden, bitte versuchen Sie es später noch einmal",
  "Crew signature": "UNTERSCHRIFT CREW",
  "Current password": "Aktuelles Passwort",
  "Damage": "Schaden",
  "Date range": "Datumsbereich",
  "Date should not be before start date": "Das Datum sollte nicht vor dem Startdatum liegen",
  "Day": "Tag",
  "Dec": "Dez",
  "DECLINED": "ABGELEHNT",
  "Default station": "Standardstation",
  "Deicing": "Enteisen",
  "Deicing Service Registration": "Registrierung des Enteisungsdienstes",
  "Delete Photo": "Foto löschen",
  "DENIED": "ABGELEHNT",
  "Describe location": "Beschreiben Sie den Standort",
  "Dest.": "Dest.",
  "Destination": "Reiseziel",
  "Did you forget something?": "Haben Sie etwas vergessen?",
  "Don't use phone while driving!": "Benutzen Sie das Telefon nicht während der Fahrt!",
  "Dummy Type": "Dummy Typ",
  "Edit Comment": "Kommentar bearbeiten",
  "Emergency": "Notfall",
  "Emergency contacts are not set up": "Notfallkontakte sind nicht eingerichtet.",
  "employees": "Mitarbeitenden vergeben",
  "End": "End",
  "End of anti-icing": "Ende der Anti-Eisbildung",
  "End Time": "Endzeit",
  "End time should not be before start time": "Die Endzeit sollte nicht vor der Startzeit liegen.",
  "Entrance": "Eingang",
  "Error loading clocked times": "Fehler beim Laden der erfassten Zeiten",
  "Error. The email doesn't meet standard formatting.": "Fehler. Die E-Mail entspricht nicht dem Standardformat.",
  "exceeds the allowed limit for this flight": " überschreitet das zulässige Limit für diesen Flug.",
  "Executor's name:": "Name des Testamentsvollstreckers:",
  "Executor's signature:": "Unterschrift des Testamentsvollstreckers:",
  "extra service": "zusätzlicher Service",
  "Extra services": "Zusätzliche Dienstleistungen",
  "Extra shift request": "Anfrage für Sonderschichten",
  "Extra Shift Request": "Anfrage für Sonderschichten",
  "Extra shift request confirmed": "Zusatzschichtanforderung bestätigt",
  "failed": "gescheitert",
  "Feb": "Feb",
  "Filter": "Filter",
  "Filter group": "Gruppe filtern",
  "Filter group has not been updated": "Die Filtergruppe wurde nicht aktualisiert",
  "filter group not found": "Filtergruppe nicht gefunden",
  "finalization": "fertigstellung",
  "Find the account recovery section and click \"Resend verification email\".": "Suchen Sie den Abschnitt zur Kontowiederherstellung und klicken Sie auf \"Bestätigungs-E-Mail erneut senden\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseFehler: Ein Dokument kann nicht geschrieben werden, da es die maximal zulässige Größe überschreitet",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: Ein Dokument kann nicht geschrieben werden, da es die maximal zulässige Größe überschreitet",
  "Flight": "Flug",
  "Flight details": "Flugdaten",
  "Flight information registration": "Registrierung von Fluginformationen",
  "Flight not found": "Flug nicht gefunden",
  "Flight number/registration": "Flugnummer/Registrierung",
  "Flight registration is closed": "Die Fluganmeldung ist geschlossen.",
  "Flight reopened": "Flug wiedereröffnet",
  "Flight type": "Flugtyp",
  "Flights": "Flüge",
  "Fluid name": "Flüssigkeitsname",
  "Fluid name:": "Flüssigkeitsname:",
  "Fluid type": "Flüssigkeitstyp",
  "Forgot your password?": "Haben Sie Ihr Passwort vergessen?",
  "Forms": "Formulare",
  "from": "von",
  "From": "Von",
  "Full (Wings, stabilizer &, fuselage)": "Voll (Flügel, Höhenleitwerk & Rumpf)",
  "Future time is not allowed": "Zukünftige Zeit ist nicht erlaubt",
  "Gate": "Tor",
  "General info": "Allgemeine Information",
  "Go to flights": "Zu den Flügen",
  "Go to login": "Zum Login",
  "Go to My Profile in your Sunrise account.": "Gehen Sie zu Mein Profil in Ihrem Sunrise-Konto.",
  "Go to Unread R&S": "Gehe zu ungelesenen Read & Signs",
  "Helpdesk": "Helpdesk",
  "Hold Inspection on Arrival": "Inspektion Laderäume (Holds) Ankunfts",
  "Hold Inspection on Departure": "Inspektion Laderäume (Holds) Abfahrt",
  "hr": "std.",
  "Humidity": "Feuchtigkeit",
  "If damage is found, mark it on the sketch": "Wenn Schäden gefunden werden, markieren Sie ihn auf der Skizze",
  "If the problem continues, go to My Profile to resend a new verification link.": "Wenn das Problem weiterhin besteht, gehen Sie zu Mein Profil, um einen neuen Bestätigungslink zu senden.",
  "In order to close this flight you need to provide": "Um diesen Flug abzuschließen, müssen Sie die erforderlichen Angaben machen.",
  "In order to close this flight you need to provide mandatory details.": "Um diesen Flug abzuschließen, müssen Sie die erforderlichen Angaben machen.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "Um den Kalender zu öffnen, müssen zuerst die Read&Sign Nachrichten gelesen und bestätigt werden.",
  "In order to send Arrival MVT you need to provide mandatory details": "Zum Senden des Arrival MVT müssen Pflichtfelder ausgefüllt werden",
  "Include nearby area": "Nahbereich einbeziehen",
  "Included nearby area": "Inklusive Nahbereich",
  "Incorrect code": "Falscher Code",
  "Input a brief description here": "Geben Sie hier eine kurze Beschreibung ein",
  "Inspected by": "Geprüft von",
  "Inspection agent's signature": "Unterschrift des Inspektionsagenten",
  "Inspection agent's signature:": "Unterschrift des Inspektionsagenten:",
  "Inspections": "Inspektionen",
  "Instructions": "Anleitungen",
  "Internal communication": "Interne Kommunikation",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Ungültige ALDT/AIBT Werte oder Arrival MVT mit diesen ALDT und AIBT Werten existiert bereits",
  "is logged in": "eingeloggt ist",
  "Is Partial": "Ist teilweise",
  "is signed in": "ist eingetragen in",
  "It's safe and encrypted - only used for password resets.": "Sie ist sicher und verschlüsselt – nur für Passwort-Zurücksetzungen verwendet.",
  "Jan": "Jan",
  "Job vacancy": "Stellenausschreibung",
  "Jul": "Jul",
  "Jun": "Jun",
  "KEY PEOPLE": "SCHLÜSSELPERSONEN",
  "Language": "Sprache",
  "Leave a comment about this timestamp and connected action.": "Hinterlassen Sie einen Kommentar zu diesem Zeitstempel und der damit verbundenen Aktion.",
  "Left Engine": "Linker Motor",
  "Left Tail Wing": "Linker Heckflügel",
  "Left Wing": "Linker Flügel",
  "Load Verification Cross-Check Form": "Crosscheck Beladung",
  "Local (Under Wing / Local area contamination)": "Lokal (Unter dem Flügel / Lokale Kontamination)",
  "Local Bags": "Lokales Gepäck",
  "Locked application": "Anwendung blockiert",
  "Log in": "Einloggen",
  "Log out": "Abmelden",
  "Lost item": "Verlorener Gegenstand",
  "lowercase": "Kleinbuchstaben",
  "Mar": "Mar",
  "Mark location": "Standort markieren",
  "May": "Mai",
  "Message archived": "Nachricht archiviert",
  "Message state": "Nachrichtenstatus",
  "Message type": "TYPE DE MESSAGE",
  "Message unarchived": "Nachricht nicht archiviert",
  "Messages": "Mitteilungen",
  "messages yet": "keine Meldungen",
  "min": "min.",
  "Mix": "Mischung",
  "Month": "Monat",
  "MVT History": "MVT-Geschichte",
  "My profile": "Mein Profil",
  "Name Surname": "Name Nachname",
  "Neck": "Cuello",
  "New password": "Neues Passwort",
  "New password cannot be equal to current": "Das neue Passwort darf nicht mit dem aktuellen übereinstimmen.",
  "New password does not meet security requirements": "Neues Passwort entspricht nicht den Sicherheitsanforderungen",
  "next": "nächste",
  "Next 5 days": "Nächste 5 Tage",
  "No": "Nein",
  "No active flights yet": "Noch keine aktiven Flüge",
  "No clocked times available": "Keine erfassten Zeiten verfügbar",
  "No content yet...": "Noch kein Inhalt...",
  "No flight details information": "Keine Informationen zu Flugdetails",
  "No instructions found": "No se encontraron instrucciones",
  "No internet connection": "Keine Internetverbindung",
  "No key people assigned.": "Keine Schlüsselpersonen zugewiesen.",
  "No messages yet": "Noch keine Meldungen",
  "No photo available": "Kein Foto vorhanden",
  "No photos here yet": "noch keine Fotos vorhanden",
  "No registration": "Keine Registrierung",
  "No services available": "Keine Dienste verfügbar",
  "No time logging found": "Kein Zeitprotokoll gefunden",
  "No timestamps configured for this flight type": "Keine Zeitstempel für diese Flugart konfiguriert",
  "No types here yet": "Noch keine Typen hier",
  "no user data": "keine Benutzerdaten",
  "None": "Keine",
  "Nose": "Nase",
  "Not completed": "Nicht abgeschlossen",
  "Note": "Hinweis:",
  "Nov": "Nov",
  "NOW": "JETZT",
  "Number of unread R&S:": "Anzahl der ungelesenen Read & Signs:",
  "numbers": "Zahlen",
  "occasion": "anlassfall",
  "Occasion": "Anlassfall",
  "Oct": "Okt",
  "Oops! It looks like your verification email didn't go through.": "Oops! Es scheint, dass Ihre Bestätigungs-E-Mail nicht durchgekommen ist.",
  "Open": "Offen",
  "Open a flight to add it to your active flights list.": "Öffnen Sie einen Flug, um ihn zu Ihrer Liste aktiver Flüge hinzuzufügen.",
  "Open file": "Datei öffnen",
  "Open flight {{name}}": "Flug {{name}} öffnen",
  "Operation flight number": "Betriebsflugnummer",
  "Operator's name": "Name des Operators",
  "Operator's name:": "Name des Bedieners:",
  "Operator's signature": "Unterschrift des Operators",
  "Operator's signature:": "Unterschrift des Bedieners:",
  "Optional": "Optional",
  "or": "oder",
  "Origin": "Herkunft",
  "Other flights": "Andere Flüge",
  "Outside Air Temperature": "Außenlufttemperatur (C°)",
  "Outside Air Temperature (C°)": "Außentemperatur (C°)",
  "Page not found": "Seite nicht gefunden",
  "Parking": "Parken",
  "Partially (Wings & stabilizer only)": "Teilweise (Flügel & Höhenleitwerk nur)",
  "Password": "Passwort",
  "Password must be at least 8 characters": "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Groß- und einen Kleinbuchstaben, ein Symbol, eine Ziffer und keine Leerzeichen enthalten.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Passwort nicht eindeutig. Ihr neues Passwort darf nicht eines Ihrer letzten 5 verwendeten Passwörter sein.",
  "Passwords do not match": "Passwörter stimmen nicht überein",
  "per occasion": "pro Anlassfall",
  "Per pax": "Pro Passagier",
  "per start": "pro Start",
  "percent": "Prozent",
  "Photo registration": "Fotoanmeldung",
  "Photo types required": "Fotoarten erforderlich",
  "Photo types required:": "Erforderliche Fototypen:",
  "Photos": "Fotos",
  "Pick if its a damaged part or lost item": "Wählen Sie, ob es sich um ein beschädigtes Teil oder einen verlorenen Gegenstand handelt",
  "Pin on schema": "Pin auf Schema",
  "Please briefly describe where you found the item": "Bitte beschreiben Sie kurz, wo Sie den Gegenstand gefunden haben. Geben Sie Raum oder Zeile und Reihe an, falls vorhanden",
  "Please click here to proceed to flights list": "Bitte klicken Sie hier, um zur Flugliste zu gelangen",
  "Please make sure you attached photos of irregularities": "Bitte stellen Sie sicher,dass Sie Fotos von Unregelmäßigkeiten angeschlossen haben",
  "Please pick on scheme": "Bitte wählen Sie ein Schema",
  "Please reach out to your administrator for assistance": "Wenden Sie sich bitte an Ihren Administrator, um Unterstützung zu erhalten.",
  "Please try sending it again later.": "Bitte versuchen Sie es später erneut.",
  "Please try the link again.": "Bitte versuchen Sie den Link erneut.",
  "Please, sign below": "Bitte, unterschreiben Sie unten",
  "Post-deicing/anti-icing check completed": "Überprüfung nach dem Enteisen/Anti-Eisbildung abgeschlossen",
  "Precipitation": "Niederschlag",
  "Pressure": "Druck",
  "Proceed to login": "Weiter zur Anmeldung",
  "Product name": "Produkt Name",
  "Product type": "Produkt Typ",
  "Profile": "Profil",
  "Profile data wasn't updated!": "Profildaten wurden nicht aktualisiert!",
  "Psychosocial aid": "Psychosoziale Hilfe",
  "Quantity (liter)": "Menge (Liter)",
  "Read": "Lesen",
  "Read & Sign": "Lesen&Unterschreiben",
  "Read & Sign to do:": "Lesen & Unterschreiben zu tun:",
  "Read&Sign": "Lesen&Unterschreiben",
  "Receive Extra shift requests": "Zusätzliche Schichtanfragen erhalten",
  "Receive job vacancies": "Erhalten Sie offene Stellen",
  recovery: {
    "error1": "<1>Hoppla!</1> Ihre Bestätigungs-E-Mail konnte nicht gesendet werden.",
    "error2": "<1>Bitte versuchen Sie es später erneut.</1>",
    "error3": "Wir entschuldigen uns für die Unannehmlichkeiten.",
    "inUse": "Diese Wiederherstellungs-E-Mail wird bereits <1>verwendet!</1>",
    "success": "Die <1>Bestätigungs-E-Mail</1> wurde erfolgreich gesendet!",
    validation: {
      "blockedDomainNote": "Eine E-Mail mit <1>@aviapartner.aero</1> oder <3>@aviavip.com</3> wird nicht akzeptiert!",
      "invalidFormat": "Fehler. Die E-Mail entspricht nicht dem Standardformat."
    },
    "verified": "Ihre Wiederherstellungs-E-Mail ist bereits <1>verifiziert!</1>"
  },
  "Recovery email": "Wiederherstellungs-E-Mail",
  "Recovery email already verified!": "Wiederherstellungs-E-Mail bereits verifiziert!",
  "Recovery email verified!": "Wiederherstellungs-E-Mail verifiziert!",
  "Reg.": "Reg.",
  "Registration": "Anmeldung",
  "Registration Closed": "Anmeldung geschlossen",
  "REGISTRATION CLOSED": "REGISTRIERUNG GESCHLOSSEN",
  "registration complete": "Registrierung abgeschlossen",
  "Remark": "Bemerkung",
  "Remove": "Entfernen",
  "Remove {{name}} from active flights": "{{name}} aus aktiven Flügen entfernen",
  "Reopen": "Wieder öffnen",
  "reopen flight": "flug wiedereröffnen",
  "Report any irregularities found upon arrival": "Melden Sie alle Unregelmäßigkeiten bei der Ankunft",
  "Report any other irregularities": "Andere Unregelmäßigkeiten melden",
  "Required": "Erforderlich",
  "required to close the flight": "erforderlich, um den Flug zu schließen",
  "Requirements of the password are not met.": "Die Anforderungen an das Passwort werden nicht erfüllt.",
  "Resend verification email": "Bestätigungs-E-Mail erneut senden",
  "Right Engine": "Rechter Motor",
  "Right Tail Wing": "Rechter Heckflügel",
  "Right Wing": "Rechter Flügel",
  "Runway": "Runway",
  "Safety Ramp Checklist": "Safety Ramp Checklist",
  "Safety Ramp Inspection": "Inspektion der Sicherheitsrampe",
  "SAVE": "Speichern",
  "save": "speichern",
  "Save service registrations problem": "Problem beim Speichern von Dienstregistrierungen",
  "Screening": "Screening",
  "Search": "Suche",
  "Seat": "Sitze",
  "Seats": "Sitze",
  "Select type": "Typ auswählen",
  "SEND ARRIVAL MVT": "Arrival MVT senden",
  "SEND CORRECTION ARRIVAL MVT": "Correction Arrival MVT senden",
  "Send the Arrival MVT message to recipients:": "Arrival MVT an Empfänger senden:",
  "SENT": "SENT",
  "Sep": "Sep",
  "Service info saved": "Service-Info gespeichert",
  "Service registration": "Serviceregistrierung",
  "Service registration is closed": "Die Anmeldung zum Dienst ist geschlossen.",
  "Service Type": "Service-Typ",
  "Set": "Satz",
  "Set date": "Datum einstellen",
  "Set time": "Zeit einstellen",
  "Set time: End of anti-icing": "Zeit festlegen: Ende der Anti-Eisbildung",
  "Set to now": "Auf jetzt einstellent",
  "Short remark": "Kurze Bemerkung",
  "Show": "Anzeigen",
  "Show Photo": "Foto anzeigen",
  "Sign for understanding": "Zeichen für Verständnis",
  "Sign form below to complete it": "Zeichenformular unten, um es auszufüllen:",
  "Sign in": "Eintragen",
  "Sign out": "Ausloggen",
  "Signed": "Unterschrieben",
  "SKIP": "ÜBERSPRINGEN",
  "Skip this step": "Überspringen Sie diesen Schritt",
  "Something went wrong": "Etwas ist schief gelaufen",
  "Something went wrong. Please try again later.": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
  "Something wrong": "Etwas stimmt nicht",
  "Sort.": "Sort.",
  "Specify where did you found the item": "Geben Sie an, wo Sie den Artikel gefunden haben",
  "Start": "Start",
  "Start anti-icing": "Anti-Icing Start",
  "Start Time": "Startzeit",
  "Station": "Bahnhof",
  "Stations": "Stationen",
  "Stop anti-icing": "Anti-Icing Ende",
  "success": "Erfolg",
  "Sunrise": "Sonnenaufgang",
  "Sunset": "Sonnenuntergang",
  "Switch flight": "Flug wechseln",
  "symbols": "Sonderzeichen",
  "SYSTEM SETTINGS": "Systemeinstellungen",
  "Tail": "Cola",
  "Take a photo": "Ein Foto machen",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Machen Sie ein Foto von einer abgeschlossenen Aktion, diesem Zeitstempel ist dieser gewidmet.",
  "Tap on area where damaged part is located": "Tippen Sie auf die Stelle, an der sich das beschädigte Teil befindet",
  "Task": "Aufgabe",
  "Tasks & Flights": "Aufgaben & Flüge",
  "Telex messages": "Telex-Nachrichten",
  "Temperature (C°)": "Temperatur (C°)",
  "The app has been updated": "Die App wurde aktualisiert",
  "The APPI code is required when resetting your Aviapartner": "Der APPI-Code wird benötigt, wenn Sie das Passwort Ihres Aviapartner-Kontos in Sunrise oder über den Aviapartner-Helpdesk zurücksetzen. Sie können Ihren APPI-Code immer in Ihrem Profil in Sunrise finden.",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "Der APPI-Code wird benötigt, wenn Sie das Passwort Ihres Aviapartner-Kontos in Sunrise oder über den Aviapartner-Helpdesk zurücksetzen. Sie können Ihren APPI-Code immer in Ihrem Profil in Sunrise finden.",
  "the correction MVT will be sent": "Nach dem Klick auf 'CONFIRM' wird das Correction MVT gesendet. Es kann erneut gesendet werden, wenn es Änderungen in ALDT und/oder AIBT gab.",
  "The current password you entered is incorrect.": "Das eingegebene aktuelle Passwort ist falsch.",
  "The current password you've entered is incorrect": "Das aktuelle Passwort, das Sie eingegeben haben, ist falsch. Bitte überprüfen Sie es noch einmal und versuchen Sie es erneut.",
  "The elapsed time between": "Die verstrichene Zeit dazwischen ",
  "The end time must be later than the start time.": "Die Endzeit muss nach der Startzeit liegen.",
  "the MVT will be sent": "Nach dem Klick auf 'CONFIRM' wird das MVT gesendet. Es kann erneut gesendet werden, wenn es Änderungen in ALDT und/oder AIBT gab.",
  "The planning shown below might not be up-to-date": "Die unten dargestellte Planung ist möglicherweise nicht aktuell.",
  "The shift is already confirmed to": "Dieser Dienst wurde bereits für",
  "The username or password you've entered is incorrect": "Der eingegebene Benutzername oder das Passwort ist falsch. Bitte überprüfen Sie es noch einmal und versuchen Sie es erneut.",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "Der Benutzername oder das Passwort, das Sie eingegeben haben, ist falsch. Bitte überprüfen Sie es und versuchen Sie es erneut.",
  "The verification email has been sent successfully!": "Die Bestätigungs-E-Mail wurde erfolgreich gesendet!",
  "This action is mandatory.": "Diese Aktion ist obligatorisch.",
  "This field is mandatory": "Dieses Feld ist obligatorisch",
  "This form is signed": "Dieses Formular ist signiert",
  "This message is marked as urgent": "Diese Nachricht ist als dringend gekennzeichnet",
  "This recovery email is already in use!": "Diese Wiederherstellungs-E-Mail wird bereits verwendet!",
  "This request is not valid anymore": "Diese Anfrage ist nicht mehr gültig",
  "This section is used to deal with visible damage to the airplane": "Dieser Abschnitt dient der Behandlung von sichtbaren Schäden am Flugzeug. Bitte dokumentieren Sie jedes auffällige Problem, bevor Sie einen Service durchführen",
  "This service has been registered for this flight over 80% of the time.": "Dieser Service wurde für diesen Flug zu über 80% der Zeit registriert.",
  "time": " zeit.",
  "Time registration": "Keine Anleitung gefunden",
  "Timeline": "Timeline",
  "Timestamp information": "Zeitstempelinformationen",
  "Timestamps type": "Typ der Zeitstempel",
  "to": "zu",
  "To get a new one, simply follow these steps:": "Um einen neuen zu erhalten, folgen Sie einfach diesen Schritten:",
  "Today": "Heute",
  "TODAY": "HEUTE",
  "Tomorrow": "Morgen",
  "Transfer Bags": "Transfergepäck",
  "Truck Driver": "LKW-Fahrer",
  "Truck driver's signature": "Unterschrift des Lkw-Fahrers",
  "Truck driver's signature:": "Unterschrift des LKW-Fahrers:",
  "Truck Number": "LKW-Nummer",
  "type": "Typ",
  "Type": "Typ",
  "Unavailable": "Nicht verfügbar",
  "Unread": "Ungelesen",
  "Until": "Bis",
  "Unverified email": "Nicht verifizierte E-Mail!",
  "uppercase": "Großbuchstaben",
  "Username": "Benutzername",
  "Username or email": "Benutzername oder E-Mail",
  "validating": "validierung",
  "validation": "validierung",
  "Verification Error": "Überprüfungsfehler",
  "Verification Link Expired": "Bestätigungslink abgelaufen",
  "Verified email": "Verifizierte E-Mail",
  verify: {
    "alreadyVerifiedTitle": "Wiederherstellungs-E-Mail bereits verifiziert!",
    "error1": "Beim Versuch, Ihre E-Mail-Adresse zu verifizieren, ist ein Fehler aufgetreten.",
    "error2": "Bitte versuchen Sie es erneut mit dem Link.",
    "error3": "Wenn das Problem weiterhin besteht, gehen Sie zu <1>Mein Profil</1>, um einen neuen Verifizierungslink zu senden.",
    "errorTitle": "Verifizierungsfehler",
    "expiredStep1": "Gehen Sie zu <1>Mein Profil</1> in Ihrem Sunrise-Konto.",
    "expiredStep2": "Finden Sie den Bereich zur Kontowiederherstellung und klicken Sie auf \"Verifizierungs-E-Mail erneut senden\".",
    "expiredStepsIntro": "So erhalten Sie einen neuen, folgen Sie einfach diesen Schritten:",
    "expiredTitle": "Verifizierungslink abgelaufen",
    "successDescription": "Sie können sie jetzt verwenden, um wieder Zugriff auf Ihr Konto zu erhalten, falls Sie Ihr Passwort vergessen.",
    "successTitle": "Wiederherstellungs-E-Mail verifiziert!",
    "verifying": "Überprüfung..."
  },
  "Verifying...": "Überprüfung...",
  "View key people": "Schlüsselpersonen anzeigen",
  "Visibility": "Sichtweite",
  "Visual checks must be performed AFTER GSE removal": "Visuelle Überprüfungen müssen nach der GSE - Entfernung durchgeführt werden",
  "Visual checks must be performed BEFORE GSE positioning": "Vor der GSE - Positionierung müssen visuelle Überprüfungen durchgeführt werden",
  "Walkaround Arrival Checklist": "Walkaround - Ankunfts - Checkliste",
  "Walkaround Pre-Departure Checklist": "Walkaround-Checkliste vor der Abteilung",
  "We apologize for the inconvenience.": "Wir entschuldigen uns für die Unannehmlichkeiten.",
  "We strongly recommend saving it in your smartphone phonebook": "Wir empfehlen dringend, ihn in Ihrem Smartphone-Telefonbuch zu speichern, damit Sie den APPI-Code immer zur Hand haben. Um den Code zu speichern, gehen Sie zu Ihrem Sunrise-Profil und scannen Sie den QR-Code mit Ihrem Smartphone.",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "Wir empfehlen dringend, ihn in Ihrem Smartphone-Telefonbuch zu speichern, damit Sie den APPI-Code immer zur Hand haben. Um den Code zu speichern, gehen Sie zu Ihrem Sunrise-Profil und scannen Sie den QR-Code mit Ihrem Smartphone.",
  "Weather": "Wetter",
  "Wind": "Wind",
  "Would you like to add it to your current registration?": "Möchten Sie ihn zu Ihrer aktuellen Registrierung hinzufügen?",
  "Write comment": "Kommentar schreiben",
  "write new comment": "neuen Kommentar schreiben",
  "Write your comment here, then press the green check mark": "Schreiben Sie hier Ihren Kommentar und drücken Sie dann das grüne Häkchen",
  "Year": "Jahr",
  "Yes": "Ja",
  "Yesterday": "Gestern",
  "You are offline": "Du bist offline.",
  "You can check your APPI code on Sunrise portal.": "Sie können Ihren APPI-Code im Sunrise-Portal überprüfen.",
  "You can now use it to regain access to your account if you forget your password.": "Sie können es jetzt verwenden, um wieder Zugriff auf Ihr Konto zu erhalten, wenn Sie Ihr Passwort vergessen.",
  "You can't remove this temporal item": "Sie können dieses zeitliche Element nicht entfernen",
  "You don't have permission to view clocked times": "Sie haben keine Berechtigung, die erfassten Zeiten anzuzeigen",
  "You don't have permissions to take a photo": "Sie haben keine Erlaubnis, ein Foto zu machen",
  "You were signed out automatically": "Sie wurden automatisch abgemeldet. Das Token ist abgelaufen. Sie können sich mit Ihren Anmeldedaten erneut anmelden",
  "Your password and confirmation password do not match": "Ihr Kennwort und das Bestätigungskennwort stimmen nicht überein.",
  "Your password has been changed successfully!": "Ihr Passwort wurde erfolgreich geändert!",
  "Your password has expired. Please compose a new password and log in again.": "Ihr Passwort ist abgelaufen. Bitte erstellen Sie ein neues Passwort und melden Sie sich erneut an.",
  "Your password must contain at least eight characters": "Ihr Passwort muss mindestens acht Zeichen, mindestens eine Zahl und sowohl Klein- als auch Großbuchstaben enthalten.",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "Ihr Passwort muss mindestens acht Zeichen, mindestens eine Zahl und sowohl Klein- als auch Großbuchstaben enthalten.",
  "Your recovery email is already verified!": "Ihre Wiederherstellungs-E-Mail ist bereits verifiziert!",
  "Your session has expired. Please sign in again.": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an."
};
